export default __webpack_public_path__ + "static/media/cp_geo_li.249e148d.svg";